import * as React from 'react';
import {Button, Modal} from 'react-bootstrap';
import {IChannel} from '../../../../data/api/models';
import FaPhone from 'react-icons/fa/phone';
import FaEnvelope from 'react-icons/fa/envelope';

interface IContactUsModalProps {
  channel: IChannel;
  text?: string;
  linkClass?: string;
}

interface IContactUsModalStates {
  showModal: boolean;
}

export default class ContactUsModal extends React.Component<IContactUsModalProps, IContactUsModalStates> {
  public state = {
    showModal: false,
  };

  private handleCloseModal = () => {
    this.setState({
      showModal: false,
    });
  }

  private openModal = () => {
    this.setState({
      showModal: true,
    });
  }

  public render() {
    const { channel, text, linkClass } = this.props;
    const { showModal } = this.state;

    return (
      <span>
        {text ? (
          <a href="#" className={linkClass ? linkClass : ''} onClick={this.openModal}>{text}</a>
        ) : (
          <Button
            id="button-contact"
            className={'center black-background'}
            onClick={this.openModal}
          >
              <img src={require('../../img/phone.svg')} alt="Contact Us" className="contactUs-size"/>
          </Button>
        )}

        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton={true} className="modal-background-black sub-content-container-alt-modal">
            <div className="title-no-border">Contact Us</div>
          </Modal.Header>
          <Modal.Body>
            <div className="contact-modal-container">
              Should you require any assistance with your quotation, then please don’t hesitate to contact us directly
              via:
              <br /><br />
              <span className="phone"><FaPhone/> {channel.phone}</span>
              <div className="opening-hours">
                Mon-Fri 09:00 - 17:00
              </div>
              <br />
              <span>
                <FaEnvelope/> <a href={`mailto:agv@bjpinsure.com`}>agv@bjpinsure.com</a>
              </span>
            </div>
          </Modal.Body>
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/ContactUsModal/index.tsx